import {
  ITastyMonialsCarouselItem,
} from "../components/TastyMonialsCarouselItem/TastMonialsCarouselItem";

export const tastyMonialsData: ITastyMonialsCarouselItem[] = [
  {
    videoSrc: "/videos/LandingPage/TastyMonials/tastymonials-card-1.webm",
    poster: "/images/landingPage/TastyMonial/tastymonials-card-1.webp",
    quote: "My cat has more energy, her coat is really soft and she never leaves any in her dish.",
    author: "Lorraine",
    rating: 5,
  },
  {
    videoSrc: "/videos/LandingPage/TastyMonials/tastymonials-card-2.webm",
    poster: "/images/landingPage/TastyMonial/tastymonials-card-2.webp",
    quote: "Our cats used to lick the jelly and leave the meat. Now they eat every morsel.",
    author: "Jacqueline",
    rating: 5,
  },
  {
    videoSrc: "/videos/LandingPage/TastyMonials/tastymonials-card-3.webm",
    poster: "/images/landingPage/TastyMonial/tastymonials-card-3.webp",
    quote: "High-quality, fresh food with real ingredients. The health difference is incredible.",
    author: "Michael",
    rating: 5,
  },
  {
    videoSrc: "/videos/LandingPage/TastyMonials/tastymonials-card-4.webm",
    poster: "/images/landingPage/TastyMonial/tastymonials-card-4.webp",
    quote: "My cat had awful diarrhoea. She was  losing weight fast. KatKin literally saved her life.",
    author: "Vanessa",
    rating: 5,
  },
];
